var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-container" }, [
    _c(
      "div",
      { staticClass: "d-flex align-items-center" },
      [
        _c("h5", { staticClass: "mb-0 mr-auto" }, [
          _vm._v("Услуги исполнителя")
        ]),
        _vm._v(" "),
        _c(
          "b-button",
          {
            staticClass: "custom-btn-primary",
            attrs: { disabled: _vm.disabled },
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.onAdd()
              }
            }
          },
          [
            _c("font-awesome-icon", {
              staticClass: "mr-1",
              attrs: { icon: "plus" }
            }),
            _vm._v("\n      Добавить\n    ")
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "page-body" },
      [
        _vm.items && _vm.items.length > 0
          ? [
              _c(
                "div",
                { staticClass: "page-table-container" },
                [
                  _c("b-table", {
                    ref: "tw_services",
                    staticClass: "custom-table text-small mb-0",
                    attrs: {
                      id: "tw-services",
                      selectable: "",
                      "select-mode": "single",
                      responsive: "",
                      items: _vm.items,
                      fields: _vm.fields,
                      "current-page": _vm.currentPage,
                      "per-page": _vm.perPage,
                      "sort-by": _vm.sortBy,
                      "sort-desc": _vm.sortDesc,
                      "sort-compare": _vm.sortCompare,
                      "no-provider-filtering": "",
                      "no-provider-paging": "",
                      "no-provider-sorting": ""
                    },
                    on: {
                      "update:sortBy": function($event) {
                        _vm.sortBy = $event
                      },
                      "update:sort-by": function($event) {
                        _vm.sortBy = $event
                      },
                      "update:sortDesc": function($event) {
                        _vm.sortDesc = $event
                      },
                      "update:sort-desc": function($event) {
                        _vm.sortDesc = $event
                      }
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "table-busy",
                          fn: function() {
                            return [
                              _c("tables-skeleton", {
                                attrs: { fields: _vm.fields, rows: 3 }
                              })
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "cell(location_work_service_id)",
                          fn: function(row) {
                            return [
                              _c("b-form-select", {
                                attrs: {
                                  id: "tw_service_id",
                                  size: "sm",
                                  disabled: _vm.disabled,
                                  value: row.item.location_work_service_id,
                                  options: _vm.twsOptions
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.onServiceSelected(row, $event)
                                  }
                                }
                              })
                            ]
                          }
                        },
                        {
                          key: "cell(quantity)",
                          fn: function(row) {
                            return [
                              _c("b-form-input", {
                                attrs: {
                                  id: "tw_quantity",
                                  size: "sm",
                                  autocomplete: "off",
                                  type: "number",
                                  min: 0,
                                  disabled: _vm.disabled,
                                  value: row.item.quantity
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.onQuantityInput(row.item, $event)
                                  },
                                  blur: function($event) {
                                    return _vm.normalizeQuantity(row.item)
                                  },
                                  keydown: _vm.preventMinus
                                }
                              })
                            ]
                          }
                        },
                        {
                          key: "cell(price)",
                          fn: function(row) {
                            return [
                              _c("b-form-input", {
                                attrs: {
                                  id: "tw_price",
                                  size: "sm",
                                  autocomplete: "off",
                                  disabled: true,
                                  value: row.item.price
                                }
                              })
                            ]
                          }
                        },
                        {
                          key: "cell(unit)",
                          fn: function(row) {
                            return [
                              _c("unit-select", {
                                key: row.item.unit_code + "-" + row.index,
                                ref: "unit_select",
                                attrs: {
                                  id: "tw_unit",
                                  "initial-unit": row.item.unit_code,
                                  "is-short": "",
                                  "is-disabled": true
                                },
                                on: {
                                  selectUnit: function($event) {
                                    return _vm.updateUnit($event, row)
                                  }
                                }
                              })
                            ]
                          }
                        },
                        {
                          key: "cell(total_price)",
                          fn: function(row) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.priceFormat(row.item.total_price)
                                  ) +
                                  "\n        "
                              )
                            ]
                          }
                        },
                        {
                          key: "cell(action)",
                          fn: function(row) {
                            return [
                              _c(
                                "b-button",
                                {
                                  staticClass: "custom-btn-danger",
                                  attrs: { disabled: _vm.disabled },
                                  on: {
                                    click: function($event) {
                                      return _vm.onRemove(row)
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", {
                                    attrs: { name: "buttons/trash", size: 14 }
                                  })
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      74902589
                    )
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "page-pagination" },
                [
                  _c("pagination-footer", {
                    attrs: {
                      "total-rows": _vm.items.length,
                      "per-page": _vm.perPage,
                      "current-page": _vm.currentPage
                    },
                    on: {
                      "update:currentPage": function($event) {
                        _vm.currentPage = $event
                      },
                      "update:current-page": function($event) {
                        _vm.currentPage = $event
                      },
                      "per-page-change": _vm.onPerPageChange
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "footer-update",
                          fn: function() {
                            return [
                              _c(
                                "span",
                                {
                                  class: {
                                    "text-danger font-weight-bold":
                                      _vm.isMismatch
                                  },
                                  attrs: { id: "total-sum-" + _vm.tw.id }
                                },
                                [
                                  _vm._v("\n            Общая сумма: "),
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(_vm.priceFormat(_vm.totalSum))
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "text-small vertical-divider"
                              }),
                              _vm._v(" "),
                              _vm.isMismatch
                                ? _c(
                                    "b-tooltip",
                                    {
                                      attrs: {
                                        target: "total-sum-" + _vm.tw.id,
                                        variant: "danger"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n            Сумма услуг исполнителя не совпадает с итого (" +
                                          _vm._s(
                                            _vm.priceFormat(_vm.tw.total_price)
                                          ) +
                                          ").\n          "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      290182170
                    )
                  })
                ],
                1
              )
            ]
          : _c(
              "div",
              { staticClass: "empty-state-container" },
              [
                _c("v-icon", {
                  attrs: { name: "navbar/empty_table", size: 90 }
                }),
                _vm._v(" "),
                _c("h5", [_vm._v("Нет добавленных услуг.")]),
                _vm._v(" "),
                _c("p", [_vm._v("Добавьте услуги исполнителя прямо сейчас")]),
                _vm._v(" "),
                _c(
                  "b-btn",
                  {
                    staticClass: "custom-btn-primary mt-1",
                    attrs: { disabled: _vm.disabled },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.onAdd()
                      }
                    }
                  },
                  [
                    _c("v-icon", {
                      staticClass: "mr-1",
                      attrs: { name: "buttons/plus", size: 12 }
                    }),
                    _vm._v("\n        Новая услуга исполнителей\n      ")
                  ],
                  1
                )
              ],
              1
            )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-670baa52", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-670baa52","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tasks/TaskWorkerServices.vue
// module id = null
// module chunks = 